import React, { useEffect, useState } from 'react';
import { MdDownloadForOffline } from 'react-icons/md';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';
import { AiTwotoneDelete } from 'react-icons/ai';
import { client, urlFor } from '../client';
import { pinDetailQuery } from '../utils/data';
import Spinner from './Spinner';
import Comments from './Comments';
import { useAlert } from 'react-alert';

const PinDetail = ({ user }) => {
  const { pinId } = useParams();
  const [pinDetail, setPinDetail] = useState();
  const [comment, setComment] = useState('');
  const [addingComment, setAddingComment] = useState(false);
  const alert = useAlert();
  const navigate = useNavigate();

  const fetchPinDetails = () => {
    const query = pinDetailQuery(pinId);

    if (query) {
      client.fetch(`${query}`).then((data) => {
        setPinDetail(data[0]);
      });
    }
  };

  const deletePin = (id) => {
    client
      .delete(id)
      .then(() => {
        navigate('/')
      });
  };

  useEffect(() => {
    fetchPinDetails();
  }, [pinId]);

  const addComment = () => {
    if (comment) {
      setAddingComment(true);
      const d = new Date();

      client
        .patch(pinId)
        .setIfMissing({ comments: [] })
        .insert('after', 'comments[-1]', [{
          comment,
          _key: uuidv4(),
          postedBy: {
            _type: 'postedBy',
            _ref: user._id
          },
          commenter: {
            userName: user?.userName,
            image: user?.profUrl,
            _id: user?._id
          },
          timeStamp: d,
        }])
        .commit()
        .then(() => {
          fetchPinDetails();
          setComment('');
          setAddingComment(false);
        });
    }
  };

  if (!pinDetail) {
    return (
      <Spinner message="Showing pin" />
    );
  }

  return (
    <>
      {pinDetail && (
        <div className="flex xl:flex-row flex-col m-auto bg-white" style={{ maxWidth: '1500px', borderRadius: '32px' }}>
          <div className="flex justify-center items-center md:items-start flex-initial">
            <img
              className="rounded-t-3xl rounded-b-lg"
              src={(pinDetail?.image && urlFor(pinDetail?.image).url())}
              alt="user-post"
            />
          </div>
          <div className="w-full p-5 flex-1 xl:min-w-620">
            <div className="flex items-center justify-between">
              <div className="flex gap-2 items-center">
                <a
                  href={`${pinDetail.image.asset.url}?dl=`}
                  download
                  className="bg-secondaryColor p-2 text-xl rounded-full flex items-center justify-center text-dark opacity-75 hover:opacity-100"
                >
                  <MdDownloadForOffline />
                </a>
              </div>
              {
                pinDetail?.postedBy?._id === user?._id && (
                  <div className="flex gap-2 items-center">
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        alert.show(
                          <div style={{ color: 'white' }}>
                            Confirm deletion of post?
                            <div className='justify-center'>
                              <button
                                type="button"
                                onClick={(e) => {
                                  deletePin(pinDetail._id);
                                }}
                                className="bg-indigo-500 text-white font-bold p-2 rounded-full w-20 outline-none justify-center"
                              >
                                Confirm
                              </button>
                            </div>
                          </div>);
                      }}
                      className="bg-secondaryColor p-2 text-xl rounded-full flex items-center justify-center text-dark opacity-75 hover:opacity-100"
                    >
                      <AiTwotoneDelete />
                    </a>
                    <a
                      onClick={(e) => {
                        e.stopPropagation();
                        console.log("Edit")
                      }}
                      className="bg-secondaryColor p-2 text-xl rounded-full flex items-center justify-center text-dark opacity-75 hover:opacity-100"
                    >
                      Edit
                    </a>
                  </div>
                )}

            </div>
            <div>
              <h1 className="text-4xl font-bold break-words mt-3">
                {pinDetail.title}
              </h1>
              <p className="mt-3">{pinDetail?.body}</p>

            </div>
            <Link to={`/user-profile/${pinDetail?.postedBy._id}`} className="flex gap-2 mt-5 items-center bg-white rounded-lg ">
              <img src={pinDetail?.postedBy.image} className="w-10 h-10 rounded-full" alt="user-profile" />
              <p className="font-bold">{pinDetail?.postedBy.userName}</p>
            </Link>
            <h2 className="mt-5 text-2xl">Comments</h2>
            <div className="max-h-370 overflow-y-auto">
              <Comments user={user} _detail={pinDetail} _id={pinId} />
            </div>
            <div className="flex flex-wrap mt-6 gap-3">
              <Link to={`/user-profile/${user._id}`}>
                <img src={user?.profUrl} className="w-10 h-10 rounded-full cursor-pointer" alt="user-profile" />
              </Link>
              <textarea
                className=" flex-1 border-gray-100 outline-none border-2 p-2 rounded-2xl focus:border-gray-300"
                type="text"
                placeholder="Add a comment"
                value={comment}
                onChange={(e) => setComment(e.target.value)}
              />

            </div>
            <button
              type="button"
              className="bg-indigo-500 text-white font-bold p-2 rounded-full w-auto m-1 outline-none"
              onClick={addComment}
            >
              {addingComment ? 'Commenting...' : 'Comment'}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default PinDetail;
